/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsers.defs.js'
export { main as default } from './getSuggestedUsers.defs.js'
